import { gql } from '@apollo/client'

export const DELETE_OR_MOVE_FILE = gql`
    mutation deleteOrMoveFile($action: DeleteOrMove!, $key: String!) {
      deleteOrMoveFile(action: $action, key: $key)  
    }
`
